import { render, staticRenderFns } from "./SubmitBtnComponent.vue?vue&type=template&id=5e1bf2fa&"
import script from "./SubmitBtnComponent.vue?vue&type=script&lang=js&"
export * from "./SubmitBtnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports